import './home.css';

function Home() {
	return (
		<div className="content home">
			<h1>What is TutorialRoach?</h1>
			<p className="info-paragraph">
				TutorialRoach is an online learning site where anyone can create
				new tutorials/lessons! TutorialRoach uses blockchain technology
				to make stored data tamperproof, making this platform very
				secure.
			</p>
		</div>
	);
}

export default Home;
